import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {

  private routerSub!: Subscription;

  private readonly SCROLL_RETRY_INTERVAL = 100;
  private readonly SCROLL_MAX_ATTEMPTS = 20;
  private readonly HEADER_OFFSET = 90;

  constructor(private router: Router) { }

  // ─────────────────────────────────────────────────────────
  //  LIFECYCLE
  // ─────────────────────────────────────────────────────────

  ngOnInit(): void {
    this.initRouteScroll();
  }

  ngOnDestroy(): void {
    // BUG FIX: original never unsubscribed — memory/navigation leak on destroy
    this.routerSub?.unsubscribe();
  }

  // ─────────────────────────────────────────────────────────
  //  ROUTE-CHANGE SCROLL
  // ─────────────────────────────────────────────────────────

  private initRouteScroll(): void {
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const url: string = event.urlAfterRedirects ?? '';
        const isHome = url === '/' || url === '';

        if (isHome) {
          window.scrollTo({ top: 0, behavior: 'auto' });
        } else {
          // BUG FIX: snap to top immediately before polling so the page
          // never stays mid-scroll while retrying
          window.scrollTo({ top: 0, behavior: 'auto' });
          this.scrollToInnerPage();
        }
      });
  }

  private scrollToInnerPage(): void {
    let attempts = 0;

    const tryScroll = (): void => {
      const target =
        (document.querySelector('#side-navigation') as HTMLElement | null) ??
        (document.querySelector('.inner-page') as HTMLElement | null);

      if (target) {
        const offsetTop = target.getBoundingClientRect().top + window.scrollY;
        const scrollTo = Math.max(0, offsetTop - this.HEADER_OFFSET);
        window.scrollTo({ top: scrollTo, behavior: 'smooth' });
        return;
      }

      if (attempts < this.SCROLL_MAX_ATTEMPTS) {
        attempts++;
        setTimeout(tryScroll, this.SCROLL_RETRY_INTERVAL);
      }
    };

    setTimeout(tryScroll, this.SCROLL_RETRY_INTERVAL);
  }

  // ─────────────────────────────────────────────────────────
  //  ROUTER OUTLET HOOK
  // ─────────────────────────────────────────────────────────

  onActivate(_event: unknown): void { }
}